import axios from 'axios'
//供应商列表
export function getSupplierList (data) {
  return axios.get(`/manage/supplier/list`, { params: data })
}
